import React from 'react';

function Minus() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.3899"
        cy="11.345"
        r="10.4085"
        fill="#F7F8FB"
        stroke="#E4E7EC"
        strokeWidth="1.09563"
      />
      <path
        d="M14.9455 11.3457V12.7838H7.65271V11.3457H14.9455Z"
        fill="#A0B1BA"
      />
      <path
        d="M14.9455 11.3457H16.0411V10.2501H14.9455V11.3457ZM14.9455 12.7838V13.8794H16.0411V12.7838H14.9455ZM7.65271 12.7838H6.55708V13.8794H7.65271V12.7838ZM7.65271 11.3457V10.2501H6.55708V11.3457H7.65271ZM13.8499 11.3457V12.7838H16.0411V11.3457H13.8499ZM14.9455 11.6881H7.65271V13.8794H14.9455V11.6881ZM8.74834 12.7838V11.3457H6.55708V12.7838H8.74834ZM7.65271 12.4414H14.9455V10.2501H7.65271V12.4414Z"
        fill="#E4E7EC"
      />
    </svg>
  );
}

export default Minus;
